import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Link, Header, Page, Content } from '@backstage/core-components';

import { DomainExplorerPage } from './DomainExplorerPage';

export const ExplorePage = () => (
  <Page themeId="home">
    <Header title="Explore Software Families" />
    <Content>
      <Grid>
        <DomainExplorerPage />
      </Grid>
      <Grid item>
        <Typography>More product information in Confluence:</Typography>
        <Link to="https://learn.mdsol.com/display/MCC/Medidata+Clinical+Cloud+Portfolio">
          Product View
        </Link>
      </Grid>
    </Content>
  </Page>
);
